import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import './cookie.less';
import {Link} from 'react-router';
import authActions from '../auth/auth_actions';
import classNames from 'classnames';
import './static_page.less';
import Header from '../header/header';
import Footer from '../footer/footer';
import DashBoardHeader from '../header_dashboard/dashboard_header';

class CookiePolicy extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {

    const {state, props} = this;
    let homePage;

    let user = {
      name: '',
      imageUrl: '',
      isVerified: ''
    };
    let isSessionValid = false;

    if('userData' in props.authState){
      isSessionValid  = props.authState.userData.sessionValid
    }

    if(isSessionValid && props.authState){
        user.name = props.authState.userData.name;
        user.imageUrl = props.authState.userData.profileImageUrl;
        user.isVerified = props.authState.userData.isVerified;
    }

    return (
      <div className="static-page cookie-policy-page">
        {!isSessionValid && <Header isFixedHeader={true} /> }
        {isSessionValid &&  <DashBoardHeader user = {user} logout={this.logout} /> }
        <div className = {classNames('static-header-wrap', {'no-margin-top' : isSessionValid})}>
          <h1 className = "static-header">Cookie Policy</h1>
        </div>
        <div className = "static-page-wrapper">
          <div className ="cookie-policy-content">
            <div className="static-content">AirWayBill, S.L., the owner of this mobile Application and Website (hereinafter, the "APP") hereby informs users that they may use data storage and recovery mechanisms (hereinafter generically referred to as "cookies") when a user browses the APP's and the Web Site's content. Cookies are files that are sent to a browser through a web server that allow to store the IP address of your device and other possible navigation data. Web Beacons are electronic web page images that enable AWB to record the number of visitors and users who have entered into a particular APP or Web Site's Content and access to certain cookies. Thanks to cookies, it is possible that the web server recognizes the browser used by the user in order to make navigation easier, as well as to measure audience and traffic parameters (through Web Beacons), and monitor progress and the number of entries. </div>

            <div className="static-content">In this sense, AWB uses cookies for which it is not necessary to obtain the users consent, as they are excluded from the scope of application of applicable Law.</div>

            <div className="static-content">Likewise, AWB uses the following cookies that require that consent of the users of the APP and web site's Content:</div>

          <div className="static-content">
            <div id="tableHeader">
              <div className="col-20 col">Tile of the cookies</div>
              <div className="col-30 col">Who is going to set cookie ?</div>
              <div className="col-50 col">Purpose</div>
            </div>
            <div id="tableContent">
              <div className="table-content-row">
                <div className="col-20 col-table">userId</div>
                <div className="col-30 col-table">AWB</div>
                <div className="col-50 col-table">To identify User</div>
              </div>
              <div className="table-content-row">
                <div className="col-20 col-table">token</div>
                <div className="col-30 col-table">AWB</div>
                <div className="col-50 col-table">Authentication and session management</div>
              </div>
              <div className="table-content-row">
                <div className="col-20 col-table">name</div>
                <div className="col-30 col-table">AWB</div>
                <div className="col-50 col-table">To identify name across the app</div>
              </div>
              <div className="table-content-row">
                <div className="col-20 col-table">profileImageUrl</div>
                <div className="col-30 col-table">AWB</div>
                <div className="col-50 col-table">To show the user image across the at the top corner</div>
              </div>
              <div className="table-content-row">
                <div className="col-20 col-table">Email</div>
                <div className="col-30 col-table">AWB</div>
                <div className="col-50 col-table">To identify user’s email</div>
              </div>
              <div className="table-content-row">
                <div className="col-20 col-table">phoneNo</div>
                <div className="col-30 col-table">AWB</div>
                <div className="col-50 col-table">To identify user’s phone number</div>
              </div>
              <div className="table-content-row">
                <div className="col-20 col-table">amplitude_id,email</div>
                <div className="col-30 col-table">Amplitude</div>
                <div className="col-50 col-table">To track the events for a user analytics purpose</div>
              </div>
              <div className="table-content-row">
                <div className="col-20 col-table">fbsr_id</div>
                <div className="col-30 col-table">Facebook Account Kit</div>
                <div className="col-50 col-table">To identify facebook user</div>
              </div>
            </div>
          </div>

          <div className="static-content" id="mobileViewTable">
      				<div className="mobileQuestion">Tile of the cookies</div>
      				<div className="mobileAnswer">userId</div>
      				<div className="mobileQuestion">Who is going to set cookie ?</div>
      				<div className="mobileAnswer">AWB</div>
      				<div className="mobileQuestion">Purpose</div>
      				<div className="mobileAnswer">To identify User</div>
    			</div>

          <div className="static-content" id="mobileViewTable">
              <div className="mobileQuestion">Tile of the cookies</div>
              <div className="mobileAnswer">token</div>
              <div className="mobileQuestion">Who is going to set cookie ?</div>
              <div className="mobileAnswer">AWB</div>
              <div className="mobileQuestion">Purpose</div>
              <div className="mobileAnswer">Authentication and session management</div>
          </div>

          <div className="static-content" id="mobileViewTable">
              <div className="mobileQuestion">Tile of the cookies</div>
              <div className="mobileAnswer">name</div>
              <div className="mobileQuestion">Who is going to set cookie ?</div>
              <div className="mobileAnswer">AWB</div>
              <div className="mobileQuestion">Purpose</div>
              <div className="mobileAnswer">To identify name across the app</div>
          </div>

          <div className="static-content" id="mobileViewTable">
              <div className="mobileQuestion">Tile of the cookies</div>
              <div className="mobileAnswer">profileImageUrl</div>
              <div className="mobileQuestion">Who is going to set cookie ?</div>
              <div className="mobileAnswer">AWB</div>
              <div className="mobileQuestion">Purpose</div>
              <div className="mobileAnswer">To show the user image across the at the top corner</div>
          </div>

          <div className="static-content" id="mobileViewTable">
              <div className="mobileQuestion">Tile of the cookies</div>
              <div className="mobileAnswer">Email</div>
              <div className="mobileQuestion">Who is going to set cookie ?</div>
              <div className="mobileAnswer">AWB</div>
              <div className="mobileQuestion">Purpose</div>
              <div className="mobileAnswer">To identify user’s email</div>
          </div>

          <div className="static-content" id="mobileViewTable">
              <div className="mobileQuestion">Tile of the cookies</div>
              <div className="mobileAnswer">phoneNo</div>
              <div className="mobileQuestion">Who is going to set cookie ?</div>
              <div className="mobileAnswer">AWB</div>
              <div className="mobileQuestion">Purpose</div>
              <div className="mobileAnswer">To identify user’s phone number</div>
          </div>

          <div className="static-content" id="mobileViewTable">
              <div className="mobileQuestion">Tile of the cookies</div>
              <div className="mobileAnswer">phoneNo</div>
              <div className="mobileQuestion">Who is going to set cookie ?</div>
              <div className="mobileAnswer">AWB</div>
              <div className="mobileQuestion">Purpose</div>
              <div className="mobileAnswer">To identify user’s phone number</div>
          </div>

          <div className="static-content" id="mobileViewTable">
              <div className="mobileQuestion">Tile of the cookies</div>
              <div className="mobileAnswer">amplitude_id, email</div>
              <div className="mobileQuestion">Who is going to set cookie ?</div>
              <div className="mobileAnswer">Amplitude</div>
              <div className="mobileQuestion">Purpose</div>
              <div className="mobileAnswer">To track the events for a user analytics purpose</div>
          </div>

          <div className="static-content" id="mobileViewTable">
              <div className="mobileQuestion">Tile of the cookies</div>
              <div className="mobileAnswer">fbsr_id</div>
              <div className="mobileQuestion">Who is going to set cookie ?</div>
              <div className="mobileAnswer">Facebook Account Kit</div>
              <div className="mobileQuestion">Purpose</div>
              <div className="mobileAnswer">To identify facebook user</div>
          </div>

          <div className="static-content">In order to revoke the consent granted for the use of cookies, the user has the possibility to disable cookies by modifying the configuration of his/her browser and/or modifying the configuration of your device, at any time.In the links below, the user will find more information on how to manage the use of cookies and disable them to revoke consent, depending upon the browser used:</div>

          <div className="static-content">
            <a className = "s-link" href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we" target = "_blank">Firefox</a>,&nbsp;
            <a className = "s-link" href="http://support.google.com/chrome/bin/answer.py?hl=es&answer=95647" target = "_blank">Chrome</a>,&nbsp;
            <a className = "s-link" href="http://support.apple.com/kb/ht1677?viewlocale=es_ES o http://support.apple.com/kb/ph5042" target = "_blank">Safari</a>,&nbsp;
            <a className = "s-link" href="http://windows.microsoft.com/es-es/windows7/how-to-manage-cookies-in-internet-explorer-9" target = "_blank">Internet Explorer</a>
          </div>
        </div>
      </div>
      <Footer />

    </div>
    );
  }
}

//connect Login modal and signup modal with actions and state
const mapStateToProps = (state) => {
  return {
    authState : state.app.auth || {}
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
      authActions : bindActionCreators(authActions, dispatch)
  }
}

CookiePolicy = connect(
  mapStateToProps,
  mapDispatchToProps
)(CookiePolicy)

export default CookiePolicy;



// WEBPACK FOOTER //
// app/static_pages/cookies.jsx